import { render, staticRenderFns } from "./materHome.vue?vue&type=template&id=e560997c&"
import script from "./materHome.vue?vue&type=script&lang=js&"
export * from "./materHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports